import PropTypes from 'prop-types'
import React, { useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import styled from 'styled-components/macro'

import { createLoan } from 'core/actions/loans'
import variables from 'core/styles/variables'

const Input = styled.input`
  margin: 0 16px;
  border: 1px solid ${variables.colorBlack50};
  padding: 4px;
`

const Button = styled.button`
  padding: 4px;
`

const CreateLoan = ({ createLoan }) => {
  const [personAddressId, setPersonAddressId] = useState('')
  const [loanTypeId, setLoanTypeId] = useState('')

  return (
    <div>
      <h3>Create loan</h3>
      <div>
        <span>personAddressId (get from available contact IDs):</span>
        <Input
          type='text'
          value={personAddressId}
          onChange={e => setPersonAddressId(e.target.value)}
        />
      </div>
      <div>
        <span>loanTypeId:</span>
        <Input
          type='text'
          value={loanTypeId}
          onChange={e => setLoanTypeId(e.target.value)}
        />
      </div>
      <div>
        <Button
          disabled={personAddressId === '' || loanTypeId === ''}
          onClick={() => createLoan({ loanTypeId, personAddressId })}
        >
          Create loan
        </Button>
      </div>
    </div>
  )
}

CreateLoan.propTypes = {
  /** Provided by mapDispatchToProps */
  createLoan: PropTypes.func
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ createLoan }, dispatch)

export default connect(null, mapDispatchToProps)(CreateLoan)
